import { Badge } from "@/components/ui/badge";

type StatusType = "draft" | "queued" | "synced" | "locked" | "error" | "offline";

interface StatusBadgeProps {
  status: StatusType;
  label?: string;
  className?: string;
}

const statusLabels: Record<StatusType, string> = {
  draft: "DRAFT",
  queued: "QUEUED",
  synced: "SYNCED",
  locked: "LOCKED",
  error: "ERROR",
  offline: "OFFLINE",
};

const statusClasses: Record<StatusType, string> = {
  draft: "status-draft",
  queued: "status-queued",
  synced: "status-synced",
  locked: "status-locked",
  error: "status-error",
  offline: "status-offline",
};

export function StatusBadge({ status, label, className = "" }: StatusBadgeProps) {
  const displayLabel = label || statusLabels[status];
  const statusClass = statusClasses[status];

  return (
    <Badge 
      variant="outline" 
      className={`${statusClass} font-mono text-xs px-2 py-1 ${className}`}
    >
      {displayLabel}
    </Badge>
  );
}
